import { BlockCardReason } from "src/app/ui/models/domains/pbm/Beneficiary/block-card-reason";
import { AbstractParser } from "../../parser";

export class BlockReasonListParser extends AbstractParser<BlockCardReason[]> {
  parse(payload: any): BlockCardReason[] {
    if (payload.error) {
      return payload.error.Data.ErrorMessage;
    }

    return payload.map((item) => {
      return new BlockCardReason(item.Name, item.LocalizedName);
    });
  }
}
